<template>
  <!-- 自助申请 -->
  <div class="page">
    <div class="apply">
      <div
        class="apply_text"
        :class="helpNum ? 'apply_activ' : ''"
        @click="help"
      >
        自助申请
      </div>
      <!-- <div
        class="apply_text"
        :class="helpNum ? '' : 'apply_activ'"
        @click="mainBtn"
      >
        自主申请
      </div> -->
    </div>
    <div v-if="helpNum">
      <div class="step">
        <div class="step_info">
          <div class="step_num" :class="helpStep === 1 ? 'step_activ' : ''">
            01
          </div>
          <div class="step_text">
            <p :class="helpStep === 1 ? 'step_activ' : ''">填写项目名称</p>
            <p>上传资料</p>
          </div>
        </div>
        <div class="arrow">
          <img src="../assets/arrow.png" alt="" />
        </div>
        <div class="step_info">
          <div class="step_num" :class="helpStep === 2 ? 'step_activ' : ''">
            02
          </div>
          <div class="step_text">
            <p :class="helpStep === 2 ? 'step_activ' : ''">选择保险公司</p>
          </div>
        </div>
        <div class="arrow">
          <img src="../assets/arrow.png" alt="" />
        </div>
        <div class="step_info">
          <div class="step_num" :class="helpStep === 3 ? 'step_activ' : ''">
            03
          </div>
          <div class="step_text">
            <p :class="helpStep === 3 ? 'step_activ' : ''">支付</p>
            <p>并提供支付凭证</p>
          </div>
        </div>
      </div>
      <!-- 第一步 -->
      <div class="info" v-if="helpStep === 1">
        <el-form
          ref="form"
          :model="form"
          label-width="160px"
          label-position="top"
          :rules="rules"
        >
          <div class="info_top">
            <div class="title">申请信息</div>
            <el-row :gutter="40">
              <el-col :span="12">
                <el-form-item label="项目名称：" prop="projectName">
                  <el-input v-model="form.projectName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="标段（标包）：">
                  <el-input v-model="form.bidName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="12">
                <el-form-item label="保证金金额（元）：" prop="guaranteeFee">
                  <!-- <el-input-number
                  v-model="form.guaranteeFee"
                  controls-position="right"
                ></el-input-number> -->
                  <el-input v-model.number="form.guaranteeFee"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="项目地区：" prop="province">
                  <el-select v-model="form.province" filterable placeholder="请选择项目地区" style="width: 100%;">
                    <el-option
                      v-for="item in provinceArr"
                      :key="item.province"
                      :label="item.provinceName"
                      :value="item.provinceName">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="info_bottom">
            <div class="upoad" style="padding-right: 20px">
              <el-form-item label="营业执照：" ref="fileName" prop="fileName" style="width: 60%;">
                <el-upload
                  class="upload-demo"
                  action="/api/AttestationController/uploadComFile"
                  :data="data"
                  accept=".jpg, .png, .bmp"
                  :on-success="success"
                  name="enterpriseInfoFile"
                  :file-list="fileList1"
                  :on-change="handleChange1"
                >
                  <div slot="tip" class="el-upload__tip">
                    支持格式：.jpg, .png且文件大小不能小于50k。
                  </div>
                  <el-button type="primary" icon="el-icon-document-add">
                    &nbsp;&nbsp;点击上传&nbsp;&nbsp;
                  </el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="招标文件：" ref="zbFileName" prop="zbFileName" style="width: 60%;">
                <el-upload
                  class="upload-demo"
                  action="/api/OfflineOrderController/uploadComFile"
                  :data="data2"
                  accept=".pdf,.doc,.docx"
                  :on-success="success1"
                  name="enterpriseInfoFile"
                  :file-list="fileList2"
                  :on-change="handleChange2"
                >
                  <div slot="tip" class="el-upload__tip">
                    支持格式：.pdf，.doc，.docx。
                  </div>
                  <el-button type="primary" icon="el-icon-document-add">
                    &nbsp;&nbsp;点击上传&nbsp;&nbsp;
                  </el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="补遗文件：">
                <el-upload
                  class="upload-demo"
                  action="/api/OfflineOrderController/uploadComFile"
                  :data="data3"
                  accept=".pdf,.doc,.docx"
                  :on-success="success2"
                  name="enterpriseInfoFile"
                  :file-list="fileList3"
                  :on-change="handleChange3"
                >
                  <div slot="tip" class="el-upload__tip">
                    支持格式：.pdf，.doc，.docx。
                  </div>
                  <el-button type="primary" icon="el-icon-document-add">
                    &nbsp;&nbsp;点击上传&nbsp;&nbsp;
                  </el-button>
                </el-upload>
              </el-form-item>
            </div>
            <div class="upoad" id="upoad">
              <div class="title">经办人信息</div>
              <el-form-item label="经办人：" prop="agentName">
                <el-input v-model="form.agentName"></el-input>
              </el-form-item>
              <el-form-item label="经办人手机：" prop="agentPhone">
                <el-input v-model="form.agentPhone"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="last">
            <el-button type="primary" @click="choice('form')">
              下一步
            </el-button>
          </div>
        </el-form>
      </div>
      <!-- 第二步 -->
      <choice  v-if="helpStep === 2" :formList="form" @step="step"/>
      <!-- 第三步 -->
      <pay v-if="helpStep==3"></pay>
    </div> 
    <div v-if="!helpNum">
      <application></application>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { getProvinceList } from "@/apis/city/index";
import Utils from "../components/util";
import Application from './application.vue';
import Choice from './choice.vue';
import Pay from './pay.vue';
export default {
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("保函金额不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      }, 500);
    };
    const phoneRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入经办人手机号"));
      } else {
        const reg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入有效的手机号"));
        }
      }
    };
    const recipientRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入经办人"));
      } else {
        const reg = /^[\u4e00-\u9fa5]*$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("经办人姓名必须为2~4位汉字"));
        }
      }
    };
    return {
      rules: {
        isRecognition: [
          { required: true, message: "请选择采用方式", trigger: "blur" },
        ],
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        bidName: [
          { required: true, message: "请输入标段（标包）", trigger: "blur" },
        ],
        guaranteeFee: [
          // { required: true, validator: checkAge, trigger: 'blur' }
          { required: true, message: "请输入保证金金额", trigger: "blur" },
          { type: "number", message: "保函金额必须为数字值" },
        ],
        agentName: [
          { required: true, validator: recipientRule, trigger: "blur" },
          { min: 2, max: 4, message: "经办人姓名必须为2~4位汉字" },
        ],
        agentPhone: [
          { required: true, validator: phoneRules, trigger: "blur" },
        ],
        zbFileName: [
          { required: true, message: "请上传招标文件", trigger: "blur" },
        ],
        fileName: [
          { required: true, message: "请上传营业执照", trigger: "blur" },
        ],
        province: [
          { required: true, message: "请选择项目地区", trigger: "blur" },
        ],
      },
      data2: null,
      data3: null,
      resource: null,
      data: null,
      form: {
        projectName: null,
        bidName: null,
        guaranteeFee: null,
        agentName: null,
        agentPhone: null,
        guaType: null,
        guaType: "2",
        userName: null,
        isRecognition: "Y",
        from: "33",
        comName: null,
        comCode: null,
        legalPersonName: null,
        comAddress: null,
        zbFileName: null,
        zbAbsolutePath: null,
        BYFileName: null,
        BYAbsolutePath: null,
        fileName: null,
        fileType: null,
        absolutePath: null,
        relativePath: null,
        // guarantorId:null,
        province:null,//省份
      },
      helpNum: true, //是否为自助申请
      helpStep: 1, //第n步
      radio: '1',
      fileList1:[],
      fileList2:[],
      fileList3: [],
      province: '',
      provinceArr:[],
    };
  },
  watch:{
    $route: {
      handler: function(route) {
        // console.log("route.query",route.query);
        const query = route.query
        if (query) {
          this.$router.go(0);
        }
      },
    }
  },
  methods: {
    success1(res) {
      console.log("Res", res);
      if (res.status > 0) {
        this.$message({
          message: "招标文件上传成功",
          type: "success",
        });
        this.form.zbFileName = res.data.zbFileName;
        this.form.zbAbsolutePath = res.data.zbAbsolutePath;
        this.$refs.zbFileName.clearValidate() 
      } else {
        this.$message.error(res.statusInfo);
      }
    },
    success2(res) {
      if (res.status > 0) {
        this.$message({
          message: "补遗文件上传成功",
          type: "success",
        });
        this.form.BYFileName = res.data.BYFileName;
        this.form.BYAbsolutePath = res.data.BYAbsolutePath;
      } else {
        this.$message.error(res.statusInfo);
      }
    },
    success(res) {
      if (res.status > 0) {
        this.$message({
          message: "营业执照上传成功",
          type: "success",
        });
        this.form.fileName = res.data.fileName;
        this.form.fileName = "1";
        this.form.absolutePath = res.data.absolutePath;
        this.form.relativePath = res.data.relativePath;
        this.form.comName = res.data.comName;
        this.form.comCode = res.data.comCode;
        this.form.fileType = res.data.fileType;
        this.form.legalPersonName = res.data.legalPersonName;
        this.form.comAddress = res.data.comAddress;
        this.$refs.fileName.clearValidate()
      } else {
        this.$message.error(res.statusInfo);
      }
    },
    application() {
      this.$router.push("/home");
    },
    choice(formName) {
      this.$refs[formName].validate((valid) => {
        this.form.userId = window.sessionStorage.getItem("userId");
        if (valid) {
          // this.$router.push({
          //   name: "choice",
          //   params: {
          //     key: this.form,
          //   },
          // });
          this.helpStep=2
        } else {
          return false;
        }
      });
    },
    help() {
      this.helpNum = true;
    },
    mainBtn() {
      this.helpNum = false;
    },
    step(v) {
      this.helpStep=v
    },
    handleChange1(file, fileList) {
      this.fileList1 = [fileList[fileList.length-1]];
    },
    handleChange2(file, fileList) {
      this.fileList2 = [fileList[fileList.length-1]];
    },
    handleChange3(file, fileList) {
      this.fileList3 = [fileList[fileList.length-1]];
    },
    getProvinceList() {
      getProvinceList().then((res) => {
        if (res.data.status > 0) {
          this.provinceArr = res.data.data;
        }
      });
    },
  },
  created() {
    this.getProvinceList()
    if (this.$route.query.orderStatus === '2') {
      this.helpStep=3
    }
    this.data = {
      userId: window.sessionStorage.getItem("userId"),
      isRecognition: "Y",
      isCompanyFlag: "N",
      type: 1,
    };
    this.data2 = {
      userId: window.sessionStorage.getItem("userId"),
      from: "33",
      type: 2,
    };
    this.data3 = {
      userId: window.sessionStorage.getItem("userId"),
      from: "33",
      type: 3,
    };
  },
  components: {Pay, Choice, Application},
};
</script>

<style lang="less" scoped>
.page {
  height: 100%;
  font-size: 16PX;
  .apply {
    background-color: #ffffff;
    display: flex;
    color: #000000;
    font-size: 14PX;
    .apply_text {
      display: flex;
      justify-content: center;
      flex: 1;
      padding: 10PX 0;
      border: 1PX solid #000000;
      cursor: pointer;
    }
    .apply_activ {
      background-color: #017eff;
      color: #ffffff;
      border: 0;
    }
  }
  .step {
    padding: 30PX 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #98a1bc;
    .step_info {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      width: 20%;
      padding: 10PX 0PX;
      background: #ffffff;
      font-weight: bold;
      .step_num {
        font-size: 3em;
        font-family: Impact;
      }
      .step_text {
        height: auto;
        margin: 0 0 10PX 10PX;
      }
      .step_activ {
        color: #017eff;
      }
    }
    .arrow {
      margin: 0 40PX;
      img {
        width: 100%;
      }
    }
  }
  .info {
    .info_top {
      background: #ffffff;
      padding: 15PX 35PX;
    }
    .info_bottom {
      background: #ffffff;
      padding: 20PX 35PX;
      margin-top: 20PX;
      display: flex;
      .upoad {
        flex: 1;
        max-width: 50%;
        // margin-top: 20PX;
      }
    }
    .last {
      width: 100%;
      text-align: center;
      background: #ffffff;
      padding-bottom: 20PX;
    }
  }
  .bank {
    background: #ffffff;
    padding: 15PX 35PX;
    .radio {
      display: flex;
      align-items: center;
      margin-top: 20PX;
      .bank_info {
        display: flex;
        justify-content: space-between;
        border: 1PX solid #000000;
        padding: 0 10PX;
      }
    }
    .footer {
      margin-top: 50PX;
      text-align: end;
    }
  }
}
::v-deep .el-form--label-top .el-form-item__label {
  padding: 0;
}

::v-deep .el-form-item__label {
  font-weight: bold;
}
</style>
